<template>
  <Modal id="onHoldModal" data-bs-backdrop="static">
    <template #header>
      <h5 class="modal-title">{{ onHoldModalData['on_hold'] ? $t('key_modal_on_hold'): $t('key_modal_available') }}</h5>
    </template>
    <template #body>
      <div v-if="onHoldModalData['on_hold']" class="row">
        <p>
          {{ $t('key_modal_markAsAvailable') }}
        </p>
      </div>
      <div v-else>
        <p>
          {{ $t('key_modal_markAsOnHold') }}
        </p>
      </div>
    </template>
    <template #footer>
      <button ref="closeButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
        {{ $t('key_cancel') }}
      </button>
      <button type="button" class="btn bg-gradient-primary" @click="confirmOnHoldStatus">
        {{ $t('key_confirm') }}
      </button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "@/components/ModalHotakauth.vue";
export default {
  components: { Modal },
  props: {
    onHoldModalData: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['confirm-on-hold-status'],
  computed: {
    newUsuario() {
      return this.$store.state.user.newUser.status;
    },
  },
  created() {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.hideModal();
      }
    });
  },
  methods: {
    hideModal() {
      let button = this.$refs.closeButton;
      if (button) button.click()
    },
    confirmOnHoldStatus() {
      let on_hold;
      if (this.onHoldModalData.on_hold) {
        on_hold = false;
      }
      else {
        on_hold = true;
      }
      this.$emit('confirm-on-hold-status', { entityId: this.onHoldModalData._id, on_hold: on_hold})
      this.hideModal()
    },
  },
};
</script>
  
<style lang="scss" scoped>

  .modal-usuarios .modal-container {
    width: 550px !important;
    height: 300px;
  }

  .was-validated .form-control:invalid, .form-control.is-invalid {
    background-position: right 1.3rem center !important;
  }

</style>